module.exports = __webpack_public_path__ + "img/onTV.59f8fb6a.svg";